import { debounce } from 'lodash';
import { MutableRefObject, useEffect } from 'react';

/**
 * scroll-snap을 사용할때 index 변경을 감지할 수 있다.
 */
const useScrollSnap = ({
  ref,
  targetArray,
  onChangeIndex,
  type,
  onChangeScrollRatio,
}: {
  ref: MutableRefObject<HTMLElement | null>;
  targetArray: any[];
  type: 'HORIZONTAL' | 'VERTICAL';
  onChangeIndex?: (index: number) => void;
  onChangeScrollRatio?: (scrollRatio: number) => void;
}) => {
  useEffect(() => {
    const modalElement = ref.current;

    if (!modalElement) return;

    const onScroll = debounce((e: Event) => {
      const { scrollTop, scrollHeight, scrollLeft, scrollWidth } =
        e.target as Element;

      // 스크롤을 얼마나 했는지 / 스크롤 전체의 양을 구함
      const totalScrollRatio = {
        VERTICAL: scrollTop / scrollHeight,
        HORIZONTAL: scrollLeft / scrollWidth,
      }[type];

      const index = totalScrollRatio * targetArray.length;

      onChangeScrollRatio?.(totalScrollRatio);
      onChangeIndex?.(Math.round(index));
    }, 100);

    modalElement.addEventListener('scroll', onScroll);

    return () => {
      modalElement.removeEventListener('scroll', onScroll);
    };
  }, [ref, targetArray, type]);

  return null;
};

export default useScrollSnap;
